import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { Login } from "../pages/Login";
import { TeacherProfile } from "../pages/TeacherProfile";
import { StudentProfile } from "../pages/StudentProfile";
import { MainLayout } from "../layouts/MainLayout";
import { StudentsSchedule } from "../pages/Schedule/StudentsSchedule";
import { TeacherSchedule } from "../pages/Schedule/TeacherSchedule";
import { Statistic } from "../pages/Statistic";
import { ClassAttendance } from "../pages/ClassAttendance";
import { Debts } from "../pages/Debts";
import { Manual } from "../pages/Manual";
import { ReportCard } from "../pages/ReportCard/ReportCard";
import AccessDenied from "../components/AccessDenied";
import NotFound from "../components/NotFound";
import RequireAuth from "../hoc/RequireAuth";

const AppRoutes = ({ isAuthenticated, roles }) => {
  const [userRoleNumber, setUserRoleNumber] = useState(null);
  const [index, setIndex] = useState([
    { label: "STUDENT", value: false },
    { label: "USER", value: false },
  ]);
  useEffect(() => {
    if (roles !== null) {
      const updatedIndex = index.map((index) => ({
        ...index,
        value: roles.includes(index.label),
      }));
      setIndex(updatedIndex);
      const stateRole = roles.includes("USER") ? 1 : 0;
      if (stateRole === 0) {
        setUserRoleNumber(0);
      } else if (stateRole === 1) {
        setUserRoleNumber(1);
      }
    }
  }, [isAuthenticated, roles]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth role={"STUDENT"}>
            <MainLayout role={userRoleNumber} />
          </RequireAuth>
        }
      >
        <Route
          // path="/student_profile"
          index={index.find((index) => index.label === "STUDENT").value}
          element={
            <RequireAuth role={"STUDENT"}>
              <StudentProfile />
            </RequireAuth>
          }
        />
        <Route
          path="/schedule/:groupId/:groupName/:correspondence"
          element={
            <RequireAuth role={"STUDENT"}>
              <StudentsSchedule />
            </RequireAuth>
          }
        />
        <Route
          path="/schedule/teacher/:teacherName"
          element={<TeacherSchedule />}
        />
        <Route
          path="/statistic"
          element={
            <RequireAuth role={"STUDENT"}>
              <Statistic />
            </RequireAuth>
          }
        />
        <Route
          path="/reportCard"
          element={
            <RequireAuth role={"STUDENT"}>
              <ReportCard />
            </RequireAuth>
          }
        />
        <Route
          path="/attendance"
          element={
            <RequireAuth role={"STUDENT"}>
              <ClassAttendance />
            </RequireAuth>
          }
        />
        <Route
          path="/debts"
          element={
            <RequireAuth role={"STUDENT"}>
              <Debts />
            </RequireAuth>
          }
        />
        <Route
          path="/manual"
          element={
            <RequireAuth role={"STUDENT"}>
              <Manual />
            </RequireAuth>
          }
        />
        <Route
          index={index.find((index) => index.label === "USER").value}
          // path="/teacher_profile"
          element={
            <RequireAuth role={"USER"}>
              <TeacherProfile />
            </RequireAuth>
          }
        />
        <Route
          path="/teacher_schedule"
          element={
            <RequireAuth role={"USER"}>
              <TeacherSchedule />
            </RequireAuth>
          }
        />
        <Route path="/access_denied" element={<AccessDenied />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
